import React, { FC } from 'react'
import { useField, useFormikContext } from 'formik'
import { FormFeedback } from 'reactstrap'
import moment from 'moment'

import { dateFormat } from 'helpers/formatter'
import { DateInput } from 'components/atoms'

export const DateField: FC<{
  name: string
  label: string
  type?: 'text' | 'number'
  size?: 'sm' | 'lg'
  disabled?: boolean
}> = ({ name, type = 'text', label, disabled = false, size, ...props }) => {
  const { setFieldValue, isSubmitting, setTouched, touched } = useFormikContext()
  const [{ onChange, value, ...field }, meta] = useField(name)

  const format = dateFormat()

  return (
    <div {...props}>
      <DateInput
        label={label}
        value={value !== null ? moment(value, format).format() : null}
        onChange={(date) => {
          const dateValue = moment(date, format).format(format)
          setFieldValue(field.name, dateValue)
          setTouched({ ...touched, [name]: true }, false)
        }}
        inputProps={{
          disabled: disabled || isSubmitting,
          invalid: !!meta.error && !!meta.touched,
          ...field,
        }}
        view="days"
        format={format}
      />

      {meta.error && meta.touched && <FormFeedback>{meta.error}</FormFeedback>}
    </div>
  )
}
